/**
 * ES6
 *
 * □機能
 * モーダル表示
 *
 */
export default (APP) => {
  /**
   * 条件検索
   *
   */
  const jobSelect = (function () {
    'use strict'

    var obj = {
      va: {
        check: {}
      },
      fl: {
        allow: false
      },
      fn: {},
      ev: {},
      el: {
        form: $('#find-v-are')
      },
      tg: {
        container: '[data-sort-contaienr]',
        sort: '[data-sort]',
        id: '[data-sort-id]',
        check: '[data-sort-check]',
        btn: '[data-sort-btn]',
        show: '[data-sort].is-show',
        wordarea: '#search-word-area',
        wordjobs: '#search-word-jobs',
        wordmerit: '#search-word-merit'
      }
    }

    obj.fn.init = function () {
      obj.el.container = $(obj.tg.container)
      obj.el.sort = $(obj.tg.sort)
      obj.el.id = $(obj.tg.id)
      obj.el.check = $(obj.tg.check)
      obj.el.btn = $(obj.tg.btn)
      obj.el.show = $(obj.tg.show)
      obj.el.wordarea = $(obj.tg.wordarea)
      obj.el.wordjobs = $(obj.tg.wordjobs)
      obj.el.wordmerit = $(obj.tg.wordmerit)
    }

    obj.fn.process = function () {
      obj.el.btn.filter('.is-validate').prop('disabled', true)
      obj.fn.validation(obj.el.btn.filter('.is-validate'))
      obj.fn.default()

      /*
      ★ 出力するテキストを作る
      * 都道府県、職種、メリットの切り分け
      * obj.va.checkから情報取得
      */

      /*
      ★ イベント：ボタン
      * UIupdate -> check
      */
      obj.el.container.on('click.sort', obj.tg.btn, function () {
        // 決定でない場合
        if ($(this).data('sort-btn') !== 'submit') {
          obj.fn.update()

          var checkObj = obj.va.check
          var $this = $(this)
          var $sort = $this.closest(obj.tg.sort)
          var sortTarget = $this.data('sort-btn')
          // var sortType = $sort.data('sort')

          // 表示切替（1階層）
          var $sortTarget = $('[data-sort="' + sortTarget + '"]')
          $sortTarget.siblings(obj.tg.sort).hide()
          $sortTarget.show()

          // 表示切替（2階層）
          for (var i = 0, l = checkObj.length; i < l; i++) {
            var id = checkObj[i]['id']
            var $sortChildTarget = $sortTarget.find(obj.tg.sort).filter('[data-sort="' + id + '"]')
            $sortChildTarget.siblings(obj.tg.sort).hide()
            $sortChildTarget.show()
          }

          // 戻るボタンの時はその箇所のcheckを外す
          if ($this.hasClass('is-return')) {
            $sort.find(obj.tg.check).prop('checked', false)
          }
        } else {
          obj.fn.update()
        }
      })

      /*
      ★ イベント：check
      * UIupdate -> check
      *
      */
      obj.el.container.on('change.sort', obj.tg.check, function (e) {
        // 県にチェックを入れると市町村は解除又はその逆
        var onlyData = e.currentTarget.getAttribute('data-sort-only')
        var sortData = e.currentTarget.getAttribute('data-sort')

        if (e.currentTarget.checked && onlyData) {
          var $sortInput = $('[data-sort="' + onlyData + '"]:checked')
          var sortLength = $sortInput.length

          if (sortLength > 0) {
            $sortInput.prop('checked', false)
          }
        } else if (sortData) {
          var $onlyInput = $('[data-sort-only="' + sortData + '"]:checked')
          var onlyLength = $onlyInput.length

          if (onlyLength > 0) {
            $onlyInput.prop('checked', false)
          }
        }

        obj.fn.update()
        obj.fn.validation($(this))
      })
    }

    // Begin function --------------------------------------------------------------- //
    /*
    * UIアップデート
    */
    obj.fn.update = function () {
      /*
      ★ チェック項目の情報を取得してオブジェクトに格納
      * 初期化
      * inputのチェック
      * checkedなら情報取得
      * obj.va.checkに格納
      * オブジェクトは変数をkeyにするため[]で
      */

      obj.va.check = []

      var checkObj = obj.va.check
      var flagCheck = false
      var countCheck = 0
      for (var i = 0, l = obj.el.check.length; i < l; i++) {
        var $this = obj.el.check.eq(i)
        flagCheck = $this.prop('checked')

        if (flagCheck) {
          var data = {}
          var type = $this.data('sort-check')
          var name = $this.attr('name')
          var value = $this.attr('data-value')
          var input = $this.attr('type')
          var id = $this.data('sort-id')

          data['sort-check'] = type || null
          data['name'] = name || null
          data['value'] = value || null
          data['input'] = input || null
          data['id'] = id || null

          obj['va']['check'][countCheck] = data

          countCheck++
        }
      }

      // 都道府県はcheckboxで一つしか選べないように
      // var quickeditCatChecklist = $('[data-sort-check="pref"]')
      // quickeditCatChecklist.on('click', function () {
      //   var isChecked = $(this).prop('checked')
      //   $(this).closest('[data-sort="pref"]').find('[data-sort-check="pref"]').prop('checked', false)

      //   if (isChecked) {
      //     $(this).prop('checked', isChecked)
      //   }
      //   // console.log( isChecked );
      // })

      obj.fn.setword(checkObj)
    }

    /*
    * デフォルト
    */
    obj.fn.default = function () {
      obj.el.show.show().siblings(obj.tg.sort).hide()
    }

    /*
    * バリデーション
    */
    obj.fn.validation = function ($btn) {
      var $this = $btn
      var $sort = $this.closest(obj.tg.sort)
      var $sortPref = $sort.filter('[data-sort="pref"]')
      var $sortJob = $sort.filter('[data-sort="job"]')

      // var checkObj = obj.va.check

      setTimeout(function () {
        // var over = obj.fn.length(checkObj, 'sort-check')
        var prefCount = $('[data-sort-check="pref"]').filter(':checked').length
        var jobCount = $('[data-sort-check="job"]').filter(':checked').length

        // 都道府県バリデーション
        if (prefCount > 1) {
          $sortPref.find('[data-sort-btn="submit"]').prop('disabled', false)
          $sortPref.find('[data-sort-btn="city"]').prop('disabled', true)
        } else if (prefCount > 0) {
          $sortPref.find('[data-sort-btn="submit"]').prop('disabled', true)
          $sortPref.find('[data-sort-btn="city"]').prop('disabled', false)
        } else {
          $sortPref.find('[data-sort-btn="submit"]').prop('disabled', true)
          $sortPref.find('[data-sort-btn="city"]').prop('disabled', true)
        }

        // 職種バリデーション
        if (jobCount > 1) {
          $sortJob.find('[data-sort-btn="submit"]').prop('disabled', false)
          $sortJob.find('[data-sort-btn="joblist"]').prop('disabled', true)
        } else if (jobCount === 1) {
          $sortJob.find('[data-sort-btn="submit"]').prop('disabled', true)
          $sortJob.find('[data-sort-btn="joblist"]').prop('disabled', false)
        } else {
          $sortJob.find('[data-sort-btn="submit"]').prop('disabled', true)
          $sortJob.find('[data-sort-btn="joblist"]').prop('disabled', true)
        }
      }, 0)
    }

    /*
    ★ 複数項目のチェック
    * obj.va.check からチェックするkeyを指定してオブジェクトで返す
    */
    obj.fn.length = function ($obj, check) {
      var checkCounts = {}
      for (var i = 0; i < $obj.length; i++) {
        var key = $obj[i][check]
        checkCounts[key] = checkCounts[key] ? checkCounts[key] + 1 : 1
      }

      return checkCounts
    }

    /*
    ★ 検索ワードのセット
    */
    obj.fn.setword = function ($obj) {
      var setword = {}
      // var name = ''
      for (var i = 0; i < $obj.length; i++) {
        var key = $obj[i]['sort-check']

        if (setword[key]) {
          setword[key] += ' , ' + $obj[i]['value']
        } else {
          setword[key] = $obj[i]['value']
        }
      }

      var area = (setword['pref']) ? setword['pref'] : ''
      area += (setword['pref'] && setword['city']) ? ' , ' : ''
      area += (setword['city']) ? '' + setword['city'] : ''
      area += (setword['ward']) ? '' + setword['ward'] : ''
      area = area || 'なし'
      var jobs = (setword['job']) ? setword['job'] : ''
      jobs += (setword['job'] && setword['joblist']) ? ' , ' : ''
      jobs += (setword['joblist']) ? '' + setword['joblist'] : ''
      jobs = jobs || 'なし'
      var merit = (setword['merit']) ? setword['merit'] : 'なし'

      obj.el.wordarea.text(area)
      obj.el.wordjobs.text(jobs)
      obj.el.wordmerit.text(merit)

      // console.log( setword )
      return setword
    }

    /*
     * モーダルオープンするときにデータをリセット
     */
    obj.fn.reset = function () {
      // check:バリデーション
      obj.fn.default()
      obj.fn.update()
      obj.fn.validation(obj.el.btn.filter('.is-validate'))
      // console.log( 'modalOpen:Do checked input(check/radio)' )

      // ターゲットの子項目をリセット //$(instance.opener().attr('href'))
      var $reset = obj.el.sort.filter(':not(.is-show)')
      $reset.prop('checked', false)
    }

    /*
     * モーダルを閉じるするときにデータをセット
     */
    obj.fn.close = function () {
      obj.fn.setword(obj.va.check)
      console.log(obj.va.check)
    }

    // End function ----------------------------------------------------------------- //

    // 処理開始
    obj.fn.begin = function () {
      if (document.querySelector('#find-v-area')) {
        obj.fl.allow = true
      } else {
        obj.fl.allow = false
        return
      }

      obj.fn.init()
      // obj.fn.reset()
      obj.fn.update()
      obj.fn.process()
    }

    // 処理終了
    obj.fn.end = function () {
      obj.fl.allow = false
    }

    return obj
  })()

  jobSelect.fn.begin()

  const modal = (function () {
    'use strict'

    // Tabキー操作可能な要素の指定
    const FOCUSABLE_ELEMENTS = 'a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, embed, [contenteditable], [tabindex]:not([tabindex^="-"])'

    const obj = {
      status: null
    }

    const el = {
      $button: document.querySelectorAll('[data-modal]'),
      $modal: document.querySelectorAll('.js-modal')
    }

    /* モーダル対象が存在しない場合は以降の処理を中断 */
    if (!el.$button) { return false }

    // メソッド格納用オブジェクト
    const fn = {}

    /**
      * ステータス判定
      * クラスに is-active の存在を確認する true で表示
      * @param element $modal（モーダル）
      * @return bool
      */
    fn.isActive = function ($modal) {
      return $modal.classList.contains('is-active')
    }

    /**
     * イベント付与: キーボード(esc)を押した際にも閉じる
     * @param element $modal
     */
    fn.handleKeydown = function (event) {
      if (event.key !== 'Escape' || !document.querySelector('.js-modal.is-active')) return false
      fn.close(event.currentTarget, false)
    }

    /**
     * コンテンツの高さとwindowの高さを取得して比較
     */
    fn.calcHeight = function ($modal, isClose) {
      const $frame = $modal.querySelector('.js-modal-frame')
      const $content = $modal.querySelector('.js-modal-content')

      if (!$frame || !$content) {
        return false
      }

      let windowHeight = window.innerHeight
      let contentHeight = $content.offsetHeight + 110

      if (contentHeight >= windowHeight) {
        $frame.style.height = '100%'
      } else {
        $frame.style.height = ''
      }

      if (isClose) {
        $frame.style.height = ''
      }
    }

    /**
     * タブキー移動の最適化
     * @param element $firstTabbable
     * @param element $lastTabbable
     */
    fn.tabkey = function ($firstTabbable, $lastTabbable) {
      $firstTabbable.addEventListener('keydown', function (event) {
        if (event.key !== 'Tab' || !event.shiftKey) {
          return
        }
        event.preventDefault()
        $lastTabbable.focus()
      }, false)

      $lastTabbable.addEventListener('keydown', function (event) {
        if (event.key !== 'Tab' || event.shiftKey) {
          return
        }
        event.preventDefault()
        $firstTabbable.focus()
      }, false)
    }

    /**
     * 承認を経てモーダルを閉じる
     * @param element $modal
     */
    fn.close = function ($modal, check) {
      obj.status = null

      if (!$modal) { return false }

      const id = $modal.getAttribute('id')
      const $button = document.querySelector('[data-modal="' + id + '"]')

      if (check) {
        if (window.confirm('閉じてもよろしいですか？')) {
          $modal.classList.remove('is-active')

          // WAI-ARIA用
          $modal.setAttribute('aria-hidden', 'true')
        }
      } else {
        $modal.classList.remove('is-active')

        // WAI-ARIA用
        $modal.setAttribute('aria-hidden', 'true')
      }

      // 初期高さ判断
      fn.calcHeight($modal, true)
      $button.focus()

      // 連携
      jobSelect.fn.close()
    }

    /**
     * モーダルを開く
     * @param element $modal
     */
    fn.open = function ($modal) {
      obj.status = $modal
      $modal.classList.add('is-active')

      // WAI-ARIA用
      $modal.removeAttribute('aria-hidden')

      // 初期高さ判断
      fn.calcHeight($modal)

      // タブで操作できる要素を取得
      const $tabbableElements = $modal.querySelectorAll(FOCUSABLE_ELEMENTS)

      // タブで操作できる最初の要素
      let $firstTabbable = $tabbableElements[0]

      // タブで操作できる最後の要素
      let $lastTabbable = $tabbableElements[$tabbableElements.length - 1]

      $firstTabbable.focus()
      fn.tabkey($firstTabbable, $lastTabbable)

      // 連携
      // jobSelect.fn.open()
    }

    /**
     * モーダル内の閉じるボタン用のイベント付与
     * モーダル内のに .js-modal-filter が存在する場合はそれをクリックでも閉じるように
     * @param element $modal
     */
    fn.triggerSetClose = function ($modal) {
      const buttonCloses = $modal.querySelectorAll('.js-modal-close')
      const $closeFilter = $modal.querySelector('.js-modal-filter')
      const modalId = $modal.getAttribute('id')

      Array.prototype.forEach.call(buttonCloses, function ($button) {
        $button.addEventListener('click', function () {
          fn.close($modal, false)
        }, false)

        // WAI-ARIA用
        $button.setAttribute('aria-label', 'モーダルウィンドウを閉じる')
        $button.setAttribute('aria-controls', modalId)
      })

      // 背景クリックでも閉じるように
      if ($closeFilter) {
        $closeFilter.addEventListener('click', function () {
          fn.close($modal, false)
        }, false)

        // WAI-ARIA用
        $closeFilter.setAttribute('tabindex', '-1')
      }
    }

    /**
     * モーダルを取得し返す
     * targetName: 対象モーダルのid名
     * @param element $button
     * @return element|bool
     */
    fn.getModal = function ($button) {
      const targetName = $button.getAttribute('data-modal')
      const _return = document.getElementById(targetName)

      if (_return) {
        return _return
      } else {
        console.log('[モーダル]：対象のモーダル（#' + targetName + 'が存在しませんでした')
        return false
      }
    }

    /**
     * クリックイベントの付与など
     */
    fn.init = function () {
      for (let i = 0, len = el.$button.length; i < len; i++) {
        const $button = el.$button[i]
        const $modal = fn.getModal($button)

        // 対象のモーダルが存在しない場合はログを出力して処理を次にスキップ
        if (!$modal) {
          $button.setAttribute('disabled', 'disabled')
          continue
        }

        /* WAI-ARIA用 - Begin */
        $modal.setAttribute('role', 'dialog')
        $modal.setAttribute('aria-modal', 'true')
        /* WAI-ARIA用 - End */

        // クリックイベントの付与
        $button.addEventListener('click', function (event) {
          const $modal = fn.getModal(event.currentTarget) // $button = event.currentTarget

          // ステータスをチェックして表示/非表示
          if (fn.isActive($modal)) {
            // 非表示
            fn.close($modal, false)
          } else {
            // 表示
            fn.open($modal)
          }
        }, false)

        // Escキーで閉じる
        $modal.addEventListener('keydown', fn.handleKeydown, false) // キーボード(esc)を押した際にモーダルを非表示に

        // 初期は必ず閉じた状態にする
        $modal.classList.remove('is-active')

        // モーダル内の閉じるボタンにイベント付与
        fn.triggerSetClose($modal)
        fn.calcHeight($modal)
      }
    }

    // アクティブなモーダルを監視
    fn.status = function () {
      return obj.status
    }

    obj.fn = fn
    obj.el = el

    return obj
  })()

  modal.fn.init()
}
